//types
import { RootState } from "../../../types/store";
//import redux
import { connect } from "react-redux";

import LayoutComponent from "./Layout.component";

// types
import { login, logout } from "../../../redux/actions/auth.actions";

const mapStateToProps = function (state: RootState) {
  return {
    auth: state.auth
  };
};

const mapDispatchToProps = function (dispatch: any) {
  return {
    login: (token: string, refreshToken: string) => dispatch(login(token, refreshToken)),
    logout: () => dispatch(logout())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);
